export { default as TabNavigation } from './TabNavigation';
export { TabContent } from './TabContent';
